<template>
<div>
    <div class="chongqing">
         <h1>山城重庆三号线轻轨碧津站附近某学校</h1>
         <div class="cqproject">
           <div class="basic_title row">
              <div class="axis"></div>
              <h6>项目概况</h6>
           </div>
           <p><span>项目地点： </span>山城重庆三号线轻轨碧津站附近某学校 </p>
           <p><span>启动原因： </span>因基坑开挖施工过程中会对周边地形产生影响，对周边构筑物产生沉降、位移等方面的安全隐患 </p>
           <p><span>项目需求： </span>保证三号线轻轨安全运营和周边楼房的安全，对该基坑周围的轻轨桥梁、学校教学楼、居民楼房进行实时变形监测 </p>
           <img src="../../assets/chongqing/1.jpg" alt="" style="width:7.32rem">
           <img src="../../assets/chongqing/2.jpg" alt="">
           <img src="../../assets/chongqing/3.jpg" alt="">
            <div class="basic_title row">
              <div class="axis"></div>
              <h6>项目实施内容</h6>
           </div>
           <p>采用岩石科技自动化变形监测系统，搭载拓普康全站仪对轨道交通3号线墩柱的水平位移、垂直位移、倾斜监测、楼房位移形变等进行实时在线自动化变形监测</p>
           <p>系统组成示意图：</p>
            <img src="../../assets/chongqing/4.jpg" alt="">
            <p><span>硬件设备： </span>拓普康DS-101AC测量机器人、岩石科技一体化监测终端RT2000 </p>
            <p><span>软件设备： </span>岩石科技数据采集软件RocMOS、岩石科技数据发布平台RocMOS-CLOUD </p>
             <div class="basic_title row">
              <div class="axis"></div>
              <h6>项目现场情况</h6>
           </div>
           <p>由于周边环境限制，观测点只能放到学校围墙上，安装仪器和监测盒子需要架竹梯踩在施工简易房上，地方狭小 </p>
           <img src="../../assets/chongqing/5.jpg" alt="">
           <p>轻轨桥监测点棱镜安装，轻轨桥比较高、直径长，再加路边行道树遮挡缘故，该处棱镜安装需要修剪树枝和错开树干，使用竹梯子较短，加大棱镜安装困难 </p>
           <img src="../../assets/chongqing/6.jpg" alt="" style="margin-top:0.2rem">
           <p>监测点棱镜学习测量 </p>
           <img src="../../assets/chongqing/7.jpg" alt="" style="margin-top:0.2rem">
            <div class="basic_title row">
              <div class="axis"></div>
              <h6>项目小结</h6>
           </div>
           <p>· RocMos系统实时运行监测后，可实时掌握该项目对轻轨的形变规律和发展趋势   </p>
           <p>· 有效监控、监视轻轨在监测期间的安全状况，通过监测及时发现异常情况和隐患，预测预报轻轨稳定状况，确保轻轨的正常运行等</p>
           <p>· 评定轻轨在基坑施工过程中的变化趋势、评定基坑施工过程中是否对轻轨产生影响</p>
         </div>
            
    </div>


    <foot></foot>

</div>
  
</template>

<style>
.chongqing {
  width: 100%;
  height: 100%;
  background-color: rgba(245, 245, 245, 1);
}
.cqproject {
  width: 11.2rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin: 0 auto;
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  margin-bottom: 0.67rem;
}
.chongqing h1 {
  font-size: 0.36rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  padding-top: 0.55rem;
  padding-bottom: 0.36rem;
  text-align: center;
}
.cqproject .axis {
  width: 0.03rem;
  height: 0.2rem;
  background: rgba(67, 148, 208, 1);
  margin-right: 0.1rem;
}
.cqproject h6 {
  font-size: 0.16rem;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: rgba(37, 43, 58, 1);
}
.cqproject .basic_title {
  margin-top: 0.34rem;
  margin-bottom: 0.04rem;
}
.cqproject p {
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
  padding-top: 0.1rem;
}
.cqproject p span {
    color: #252B3A;
    font-weight: bold;
}
.cqproject img{
    width: 7.2rem;
    margin-top: .1rem;
}
.cqproject p:last-child{
    padding-bottom: .49rem;
}
</style>

<script>
import footer from "../../common/footer";
export default {
  data() {
    return {};
  },
  components: {
    foot: footer
  }
};
</script>


// WEBPACK FOOTER //
// src/homepages/casepage/chongqing.vue